import React, { useEffect, useState } from 'react';
import CalendarSheet from '../../../Components/Calendar/CalanderSheet';
import { getDayDetails } from '../helpers';
import {
  GET_APPOINTMENT_CALENDAR_EVENTS,
  GET_CALENDAR_VIEW_EVENTS,
  TicketClient,
  useCachedQuery
} from '@nile/graphql/src';
import { useQuery } from '@apollo/client';
import EventComponent from './EventComponent';
import EventWrapper from './EventWrapper';
import { Modal } from '@superops/ui-design-system';
import { useLazyQuery } from '@apollo/client';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';

const AppointmentFormCalendar = (props) => {
  const InitialDayDetails = getDayDetails(props?.date);
  const [calendarSheetDate, setCalendarSheetDate] = useState(props?.date);
  const [calendarSheetDay, setCalendarSheetDay] = useState(InitialDayDetails);
  const [calendarSheetEvents, setCalendarSheetEvents] = useState(
    props?.events || []
  );
  const [loading, setLoading] = useState(false);

  const calendarSheetDayRef = React.useRef(null);
  calendarSheetDayRef.current = calendarSheetDay;

  const getCalendarVariables = (startTime, endTime) => {
    const attendees = [];
    props?.attendees?.forEach((el) => {
      const userId = el?.userId;
      if (userId) {
        attendees.push(userId);
      }
    });
    return {
      input: {
        groupBy: {
          attribute: 'appointment.attendees.user.userId'
        },
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'eventType',
              operator: 'is',
              value: 'APPOINTMENT'
            },
            {
              attribute: 'appointment.attendees.user.userId',
              operator: 'includes',
              value: attendees
            },
            {
              joinOperator: 'OR',
              operands: [
                {
                  attribute: 'startTime',
                  operator: 'between',
                  value: [startTime, endTime]
                },
                {
                  attribute: 'endTime',
                  operator: 'between',
                  value: [startTime, endTime]
                }
              ]
            }
          ]
        }
      }
    };
  };

  const fetchCalendar = (variables) => {
    setLoading(true);
    TicketClient.query({
      query: GET_APPOINTMENT_CALENDAR_EVENTS,
      fetchPolicy: 'network-only',
      variables: variables
    })
      .then((res) => {
        setLoading(false);
        const eventsFromRespose = res?.data?.getCalendarView;
        const formattedEvents = [];
        const blockEvent = calendarSheetEvents.find(
          (el) => el?.eventType === 'BLOCK_EVENT'
        );
        if (blockEvent) {
          formattedEvents.push(blockEvent);
        }

        eventsFromRespose.forEach((el) => {
          const userId = el?.header?.value?.userId;
          const events = el?.events || [];
          events?.forEach((event) => {
            const allAttendees = event?.appointment?.attendees;
            const currentAttendees = allAttendees.filter(
              (attendee) => attendee?.user?.userId === userId
            );
            const appointment = {
              ...event?.appointment,
              attendees: currentAttendees
            };

            formattedEvents.push({
              start: new Date(event?.startTime),
              end: new Date(event?.endTime),
              ...event,
              disableEvents: true,
              showUser: true,
              appointment: appointment
            });
          });
        });
        setCalendarSheetEvents(formattedEvents);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // const [fetchCalendar, { data, loading }] = useLazyQuery(
  //   GET_APPOINTMENT_CALENDAR_EVENTS,
  //   {
  //     client: TicketClient,
  //     fetchPolicy: 'network-only',
  //     skip: !props?.active,
  //     onCompleted(res) {
  //       const events = res?.getCalendarView?.[0]?.events;
  //       if (events) {
  //         const formattedEvents = [];
  //         events.forEach((el) => {
  //           formattedEvents.push({
  //             start: new Date(el?.startTime),
  //             end: new Date(el?.endTime),
  //             ...el,
  //             disableEvents: true
  //           });
  //         });
  //         setCalendarSheetEvents(formattedEvents);
  //       }
  //     }
  //   }
  // );

  useEffect(() => {
    const startTime = calendarSheetDayRef.current?.startTime;
    const endTime = calendarSheetDayRef.current?.endTime;
    if (startTime && endTime) {
      const variables = getCalendarVariables(startTime, endTime);
      fetchCalendar(variables);
    }
  }, []);

  const onCalendarSheetDayChange = (date) => {
    setCalendarSheetDate(date);
    const dayDetails = getDayDetails(date);
    if (dayDetails?.startTime && dayDetails?.endTime) {
      const variables = getCalendarVariables(
        dayDetails?.startTime,
        dayDetails?.endTime
      );
      fetchCalendar(variables);
    }

    setCalendarSheetDay(dayDetails);
  };

  const updateBgEvent = (data) => {
    const allEvents = cloneDeep(calendarSheetEvents);
    const start = dayjs(data?.start);
    const end = dayjs(data?.end);

    const startDate = dayjs(start).format('YYYY-MM-DD');
    const endDate = dayjs(end).format('YYYY-MM-DD');

    const isStartAndEndTimeSame = dayjs(end).isSame(dayjs(start));
    const isInSameDate = startDate === endDate;

    if (!isStartAndEndTimeSame && isInSameDate) {
      const updatedEvents = allEvents.map((el) => {
        if (el?.eventType === 'BLOCK_EVENT') {
          return {
            start: data?.start,
            end: data?.end,
            eventType: 'BLOCK_EVENT'
          };
        } else {
          return el;
        }
      });
      setCalendarSheetEvents(updatedEvents);
    }
  };

  const onClose = () => {
    const updatedTime = calendarSheetEvents.find(
      (el) => el?.eventType === 'BLOCK_EVENT'
    );
    props?.onClose(updatedTime);
  };

  return (
    <>
      <CalendarSheet
        sheetActive={props?.active}
        setSheetActive={props?.setActive}
        onClose={onClose}
        date={calendarSheetDate}
        events={calendarSheetEvents}
        components={{
          event: EventComponent,
          eventWrapper: EventWrapper
        }}
        loading={loading}
        step={30}
        timeslots={2}
        day={calendarSheetDay}
        onDayChange={onCalendarSheetDayChange}
        zIndex={525}
        enableDragAndDrop
        onEventResize={updateBgEvent}
        onEventDrop={updateBgEvent}
        className="appointment-form-calendar"
        hideButtons
        disableCalendar
      />
    </>
  );
};

export default AppointmentFormCalendar;
